import { OrganizationCloseStage } from "@common/types/organizationCloseStage";
import { Button } from "@design-system/Button/Button";
import { HStack } from "@design-system/HStack/HStack";
import { AddStageCombobox } from "./AddStageCombobox";
import styles from "./CloseTemplateTasksDrawer.module.scss";

interface Props {
    hiddenStages: OrganizationCloseStage[];
    onAddStage: (stageId: string) => void;
    onAddTask: () => void;
}

export const CloseTemplateTasksEmptyView = ({
    hiddenStages,
    onAddStage,
    onAddTask,
}: Props) => (
    <div className={styles.emptyView}>
        <span className={styles.emptyViewHeader}>
            Start adding your stages and tasks
        </span>
        <HStack gap={8}>
            <AddStageCombobox
                hiddenStages={hiddenStages}
                onAddStage={onAddStage}
            />
            <Button variant="primary" size="md" onClick={onAddTask}>
                Add task
            </Button>
        </HStack>
    </div>
);
